import React from 'react'
import '../Layout/Layout.css';

const Footer = () => {
  return (
    <div className='footer'>
            
            <p id='copyright'> © Copyright 2023 | Tous droits reservées</p>
                    
        </div>
  )
}

export default Footer